var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid my-4"},[_c('iframe',{staticClass:"w-100 border-0",staticStyle:{"height":"1200px"},attrs:{"src":'https://app.pandadoc.com/a/#/document/v1/editor/' + _vm.budget.quote.uuid + '/content'}})])}
var staticRenderFns = []

export { render, staticRenderFns }